<template>
  <div class="table-responsive">
    <table class="table" :class="`table-${theme}`">
      <tr class="table-row">
        <th class="p-3"></th>
        <th class="p-3">{{ $t('js.backend.ballot_summary.voter_counts.voted') }}</th>
        <th class="p-3">{{ $t('js.backend.ballot_summary.voter_counts.active_eligibles_or_voted') }}</th>
        <th class="p-3">{{ $t('js.backend.ballot_summary.voter_counts.total_eligibles') }}</th>
      </tr>
      <tr class="table-row">
        <th class="p-3">{{ $t('js.backend.ballot_summary.voter_counts.by_individual') }}</th>
        <td class="p-3">{{ turnout.voted }}</td>
        <td class="p-3">{{ turnout.present }}</td>
        <td class="p-3">{{ turnout.eligible }}</td>
      </tr>
      <tr class="table-row">
        <th class="p-3">{{ $t('js.backend.ballot_summary.voter_counts.by_weight') }}</th>
        <td class="p-3">{{ turnout.votedWeight }}</td>
        <td class="p-3">{{ turnout.presentWeight }}</td>
        <td class="p-3">{{ turnout.eligibleWeight }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'TurnoutTable',
  props: {
    turnout: {},
    theme: {
      type: String,
      default: "dark"
    }
  }
}
</script>
<style>
.table-row {
  border-bottom: solid 1px;
}
</style>